<template>
  <v-layout row justify-center>
    <v-dialog v-model="localShow" persistent :max-width="width" :fullscreen="fullscreen" :scrollable="true">
      <v-card>
        <v-card-title class="headline white--text green darken-1">
          <v-layout row wrap>
            <v-flex xs11>
              <slot name="title" />
            </v-flex>

            <v-spacer />

            <v-flex xs1 class="text-xs-right">
              <v-btn aria-label="Zamknij" icon small flat color="white" @click="close">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-card-text v-if="$slots.default" :style="fullscreen ? 'height: 90%' : ''">
          <slot />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <slot name="actions" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: '600'
    },
    fullscreen: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  },
  data() {
    return {
      localShow: undefined
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.localShow = val;
      }
    }
  }
};
</script>
